import { FC, useCallback, useState } from 'react'

import { BatchView } from 'bank-bsa-reporting/src/components/BatchView'
import { BsaBatches } from 'commons/types/DTO/bank/alerts/bsaBatches'
import { BsaBatch } from 'commons/types/DTO/bank/bsa'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'

export const BSATable: FC = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { bsaBatchesPage, bsaBatchesSize },
    showBsaBatches,
    showBsaBatchesTotalCount
  } = data

  const [modalItem, setModalItem] = useState<BsaBatch | null>(null)

  const onClose = useCallback(() => setModalItem(null), [])

  const onSetModalItem = useCallback((item: BsaBatches) => {
    const mappedItem: BsaBatch = {
      id: item.id,
      ctrs_info: item.CTRs.map((ctr) => ({
        ctr_id: ctr.id,
        ctr_name: ctr.name,
        ctr_status: ctr.status.toLowerCase()
      }))
    }
    setModalItem(mappedItem)
  }, [])

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'bsaBatches')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="BSA Batches to finalize" anchor="batch">
      <BatchView item={modalItem} onClose={onClose} />
      <Layer rounded shadowed stretch>
        <Table<BsaBatches>
          dataQa={TableDataQa.BP_ALERTS_BSA_BATCHES}
          columns={columns({ onShowBatch: onSetModalItem })}
          dataSource={showBsaBatches.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('bsaBatches')}
          pagination={{
            page: bsaBatchesPage || 1,
            size: bsaBatchesSize || 10,
            onChange: handlePageChange,
            total: showBsaBatchesTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
